import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fcc0722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-hidden": "true" }
const _hoisted_2 = { class: "delivery-option mb-x2" }
const _hoisted_3 = { class: "mx-30" }
const _hoisted_4 = { class: "flex mt-40 mb-30" }
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = { class: "ml-auto max-w-half" }

import CheckoutSkeletonLine from '@/storecontext/shared/checkout/ui/CheckoutSkeletonLine.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickUpDeliverableSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CheckoutSkeletonLine, { class: "mb-10 sm:w-150" }),
        _createVNode(CheckoutSkeletonLine, { class: "sm:w-50" }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(CheckoutSkeletonLine, { class: "mb-8" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-8" }),
            _createVNode(CheckoutSkeletonLine, { class: "mb-8" })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(CheckoutSkeletonLine, { class: "min-w-250" })
          ])
        ])
      ])
    ])
  ]))
}
}

})